<template>
<SocketProvider>
  <div id="app" class="sa-container">
    <router-view></router-view>
    <!-- video call ringer -->
    <ringer v-if="isRinging" />
    <!-- video call participant frames -->
    <!-- <video-call-view v-if="inCall" /> -->
      <!-- video call -->
    <video-call />
    <div v-if="loading" class="sa-loader-bg">
      <img src="/static/img/loader.svg" alt="loader" class="sa-loader" />
    </div>
  </div>
  </SocketProvider>
</template>
<script>
import { mapGetters } from "vuex";

import SocketProvider from './DataProviders/SocketProvider';
const Ringer = () =>
  import(/* webpackChunkName: "ringer" */ "./components/chat/Ringer.vue");
const VideoCallView = () =>
  import(/* webpackChunkName: "video-view" */ "./components/chat/VideoCallView.vue");
  const VideoCall = () => import(/* webpackChunkName: "videocall" */ "./components/video-call/VideoCall.vue");
import { ConnectionStatus } from "./util/common";
import uniqid from "uniqid";
import io from "socket.io-client";
import { SOCKETHUB_ENDPOINT } from "./config";
import { bus } from "./main";
import i18n from "./i18n";

export default {
  name: "App",
  components: {
    Ringer,
    // VideoCallView,
    VideoCall,
    SocketProvider,
  },
  watch: {},
  data() {
    return {
      socket: null,
      socketId: null,
      did: uniqid()
    };
  },
  computed: {
    ...mapGetters({
            videocallPayload: "videocall/getIncomingCallPayload"
        }),
    isRinging() {
      return this.$store.getters["videocall/isRinging"];
    },
    inCall() {
      let callConnectionStatus = this.$store.getters["videocall/inCallStatus"];
      if(callConnectionStatus != 'disconnected'){
        return (
          callConnectionStatus === ConnectionStatus.CONNECTED ||
          callConnectionStatus === ConnectionStatus.IN_PROGRESS
        );
      }else{
        return false
      }
    },
    notificationPayload() {
      return this.$store.getters["common/getNotificationPayload"];
    },
    loading() {
      return this.$store.getters["UI/loading"];
    },
  },
  mounted() {
    // bus.$on('SOCKET_INIT', this.socketInit)
    // bus.$on("DECLINE_CALL", this.declineCall);
    // bus.$on("ACCEPT_CALL", this.acceptCall);
  },
  methods: {
  
  },
};
</script>


// WEBPACK FOOTER //
// src/App.vue